// extracted by mini-css-extract-plugin
export default {"patient_row_active":"WorkQRow_patient_row_active__YZH6K","hold_status":"WorkQRow_hold_status__N3ynI"};